/* eslint-disable no-use-before-define */
import * as tmsEventsApi from '../api/tmsEventsApi';
import * as eventsApi from '../api/eventsApi';
import * as clubsApi from '../api/clubsApi';
import * as api from '../api';
import { acceptanceRankingValues, divisionFormatTypeIds, drawCategoryTypeIds, drawEliminationTypeIds, drawScheduleTypeIds, eventFormatTypeIds, sportTypeIds } from '../utils/eventConstants';
import { getApiErrorMessage } from '../utils/apiError';
import { EventTypes } from '../utils/events';
import { populateTeamsForSave, populateMemberArraysForSave, populateMatchUpdateList, populatePrintMatchSheetUpdateList, populatePrintMultipleMatchesSheetUpdateList } from '../utils/draws';
import { responseStatusTypes, sortParamTypes } from '../utils/constants';
import { findMatchAcrossSlices } from '../utils/postScoreCascade';

import {
    DRAW_EDIT_GET_EVENT,
    DRAW_EDIT_GET_EVENT_SUCCESS,
    DRAW_EDIT_GET_EVENT_FAILURE,
    DRAW_EDIT_GET_CLUB_SUCCESS,
    DRAW_EDIT_GET_CLUB_OFFICIAL_MEMBERS_SUCCESS,
    DRAW_EDIT_GET_CLUB_OFFICIAL_MEMBERS_FAILURE,
    DRAW_EDIT_GET_DRAWS_SUCCESS,
    DRAW_EDIT_GET_PLAYERS_SUCCESS,
    DRAW_EDIT_GET_TEAMS_SUCCESS,
    DRAW_EDIT_GET_DRAW_SUCCESS,
    DRAW_EDIT_ADD_TO_DRAW,
    DRAW_EDIT_REMOVE_FROM_DRAW,
    DRAW_EDIT_ADD_TO_MATCH,
    DRAW_EDIT_CREATE_TEAM,
    DRAW_EDIT_ADD_TEAM_TO_EVENT,
    DRAW_EDIT_SPLIT_TEAMS,
    DRAW_EDIT_SET_SELECTED,
    DRAW_EDIT_SET_SELECTED_ND,
    DRAW_EDIT_SET_SELECTED_TEAMS,
    DRAW_EDIT_SET_SELECTED_TEAMS_ND,
    DRAW_EDIT_SET_PREVENT_SELECT_MOVE,
    DRAW_EDIT_ORDER_PLAYERS,
    DRAW_EDIT_AUTOFILL,
    DRAW_EDIT_AUTOFILL_SUCCESS,
    DRAW_EDIT_AUTOFILL_FAILURE,
    DRAW_EDIT_SET_PLAYER_STATUS,
    DRAW_EDIT_SET_DRAW_TAG,
    DRAW_EDIT_SET_DRAW_TAG_SUCCESS,
    DRAW_EDIT_SAVE,
    DRAW_EDIT_SAVE_SUCCESS,
    DRAW_EDIT_SAVE_FAILURE,
    DRAW_EDIT_SAVE_SUCCESS_HIDE,
    DRAW_EDIT_GET_MATCH_SUCCESS,
    DRAW_EDIT_UPDATE_SCHEDULE_TYPE,
    DRAW_EDIT_SET_RESET_TIMER,
    DRAW_EDIT_SET_SAVING_FLAG,
    // -----------------------------
    DRAW_EDIT_GET_ACCEPTANCE_LIST,
    DRAW_EDIT_GET_ACCEPTANCE_LIST_SUCCESS,
    DRAW_EDIT_GET_ACCEPTANCE_LIST_FAILURE,
    DRAW_EDIT_GET_ORGANIZER_RATINGS_SUCCESS,
    DRAW_EDIT_SET_ORGANIZER_RATINGS_SUCCESS,
    DRAW_EDIT_SET_PLAYER_WILDCARD,
    DRAW_EDIT_SET_PLAYER_WILDCARD_SUCCESS,
    DRAW_EDIT_LOCATIONS_FETCH_REQUEST,
    DRAW_EDIT_LOCATIONS_FETCH_FAILURE,
    DRAW_EDIT_LOCATIONS_FETCH_SUCCESS,
    DRAW_EDIT_FACILITIES_FETCH_REQUEST,
    DRAW_EDIT_FACILITIES_FETCH_FAILURE,
    DRAW_EDIT_FACILITIES_FETCH_SUCCESS,
    DRAW_EDIT_LOCATIONS_EXCLUDE_REQUEST,
    DRAW_EDIT_LOCATIONS_EXCLUDE_SUCCESS,
    DRAW_EDIT_LOCATIONS_EXCLUDE_FAILURE,
    DRAW_EDIT_OFFICIALS_FETCH_REQUEST,
    DRAW_EDIT_OFFICIALS_FETCH_SUCCESS,
    DRAW_EDIT_OFFICIALS_FETCH_FAILURE,
    DRAW_EDIT_GET_DRAW_OFFICIALS_REQUEST,
    DRAW_EDIT_GET_DRAW_OFFICIALS_SUCCESS,
    DRAW_EDIT_GET_DRAW_OFFICIALS_FAILURE,
    DRAW_EDIT_DELETE_MATCH_OFFICIAL_REQUEST,
    DRAW_EDIT_DELETE_MATCH_OFFICIAL_FAILURE,
    DRAW_EDIT_FETCH_MATCH_SHEET_SUCCESS,
    DRAW_EDIT_EVENT_TEAM_STANDINGS_SUCCESS,
    DRAW_EDIT_UPDATE_MATCH_SHEET_SUCCESS,
    DRAW_EDIT_UPDATE_MATCH_SHEET_ROUND_REQUEST,
    DRAW_EDIT_UPDATE_MATCH_SHEET_ROUND_SUCCESS,
    DRAW_EDIT_UPDATE_MATCH_SHEET_ROUND_FAILURE,
    DRAW_EDIT_UPDATE_MATCH_SHEET_REQUEST,
    DRAW_EDIT_DELETE_MATCH_SHEET_SUCCESS,
    DRAW_EDIT_UPDATE_MATCH_SHEET_FAILURE,
    DRAW_EDIT_GET_ORDER_OF_PLAY_SUCCESS,
    DRAW_EDIT_SAVE_ORDER_OF_PLAY_SUCCESS,
    DRAW_EDIT_DELETE_ORDER_OF_PLAY_SUCCESS,
    DRAW_EDIT_GET_ORDER_OF_PLAY_MATCHES_SUCCESS,
    DRAW_EDIT_OFFICIALS_UPDATE_REQUEST,
    DRAW_EDIT_OFFICIALS_UPDATE_SUCCESS,
    DRAW_EDIT_OFFICIALS_UPDATE_FAILURE,
    DRAW_EDIT_GET_MATCH_OFFICIALS_REQUEST,
    DRAW_EDIT_GET_MATCH_OFFICIALS_SUCCESS,
    DRAW_EDIT_GET_MATCH_OFFICIALS_FAILURE,
    DRAW_EDIT_ADD_MATCH_OFFICIAL_REQUEST,
    DRAW_EDIT_ADD_MATCH_OFFICIAL_FAILURE,
    DRAW_EDIT_REINIT,
    DRAW_EDIT_PUBLISH,
    DRAW_EDIT_PUBLISH_FAILURE,
    DRAW_EDIT_PUBLISH_SUCCESS,
    DRAW_EDIT_SET_MOVE_FAILED_PLAYERS,
    DRAW_EDIT_GET_DRAW_DIVISION_ASSOCIATION_SUCCESS,
    DRAW_EDIT_CONFIRM_DIVISION_DRAW_ASSOCIATION_SUCCESS,
    DRAW_EDIT_GET_PLAYERS_FAILURE,
    DRAW_EDIT_GET_DRAWS_PUBLISH_INFO_SUCCESS,
    DRAW_EDIT_TOGGLE_SMS_FLAG,
} from './actionTypes/draw-edit-action-types';
import { showErrorPopup, showErrorToast, showSuccessToast } from './notification-actions';

export const reInitRedux = () => (dispatch) => {
    dispatch({ type: DRAW_EDIT_REINIT });
};

export const getEvent = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: DRAW_EDIT_GET_EVENT });
    try {
        const res = await tmsEventsApi.getDrawEditEvent(mainApi, { eventId });
        if (res.data.error) {
            dispatch({
                type: DRAW_EDIT_GET_EVENT_FAILURE,
                res,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
            dispatch(showErrorPopup({
                message: 'Error loading event',
                error: res.data.error,
            }));
        } else {
            if (res.data.scheduleTypeId === drawScheduleTypeIds.ORDER_OF_PLAY) {
                dispatch(getOrderOfPlay(eventId));
                dispatch(getOrderOfPlayMatches(eventId));
            }
            if (res.data.scheduleTypeId === drawScheduleTypeIds.MATCH_SHEET) {
                dispatch(getMatchSheet(eventId));
            }
            if (res.data.eventTypeId === EventTypes.TEAM_LEAGUE) {
                dispatch(getEventTeamStandings(eventId));
            }
            dispatch({
                type: DRAW_EDIT_GET_EVENT_SUCCESS,
                payload: res.data,
            });
            dispatch(getDraws(eventId));
            dispatch(getDivisionDrawAssociation(eventId));
            dispatch(getEventLocations(eventId));
            dispatch(getEventFacilities(eventId));
            dispatch(getEventOfficials(eventId));
            dispatch(getClubOfficialMembers(res.data.club.id));
            return res.data;
        }
    } catch (error) {
        const redirectUrl = `/`;
        dispatch({
            type: DRAW_EDIT_GET_EVENT_FAILURE,
            payload: { redirectUrl },
        });
        dispatch(showErrorPopup({
            message: 'Error loading event',
            error,
        }));
    }
};
export const getClub = (clubId) => async (dispatch, getState, { mainApi }) => {
    const res = await clubsApi.getClub(mainApi, clubId);
    dispatch({ type: DRAW_EDIT_GET_CLUB_SUCCESS, payload: res.data });
};
export const getClubOfficialMembers = (clubId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await clubsApi.getClubOfficialMembers(mainApi, clubId);
        dispatch({ type: DRAW_EDIT_GET_CLUB_OFFICIAL_MEMBERS_SUCCESS, payload: res.data });
    } catch {
        dispatch({
            type: DRAW_EDIT_GET_CLUB_OFFICIAL_MEMBERS_FAILURE,
        });
    }
};
export const getDraws = (eventId) => async (dispatch, getState, { mainApi }) => {
    const res = await tmsEventsApi.getDrawEditDraws(mainApi, { eventId });
    dispatch({ type: DRAW_EDIT_GET_DRAWS_SUCCESS, payload: res.data });
    // load players and after draws success (to populate players with draws data)
    dispatch(getPlayersV3(eventId));
};
export const getPlayersV3 = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.getAllPlayers(mainApi, { eventId });
        dispatch({ type: DRAW_EDIT_GET_PLAYERS_SUCCESS, payload: res.data });
        // load teams after players success (to populate teams with players data)
        dispatch(getTeams(eventId));
    } catch (error) {
        dispatch({ type: DRAW_EDIT_GET_PLAYERS_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error getting the player details',
            error,
        }));
    }
};

export const getTeams = (eventId) => async (dispatch, getState, { mainApi }) => {
    const { currentDraw, event } = getState().drawEdit;
    const res = await tmsEventsApi.getDrawEditTeams(mainApi, { eventId });
    dispatch({ type: DRAW_EDIT_GET_TEAMS_SUCCESS, payload: res.data });
    if (currentDraw.data) {
        const isSingles = currentDraw.data.formatTypeId === eventFormatTypeIds.SINGLES;
        const isPickleballEvent = event.data?.sportTypeId === sportTypeIds.PICKLEBALL;
        let sortParam = isSingles ? sortParamTypes.SINGLESUTR : sortParamTypes.DOUBLESUTR;
        if (isPickleballEvent) {
            sortParam = isSingles ? sortParamTypes.SINGLESPKB : sortParamTypes.DOUBLESPKB;
        }
        dispatch(orderPlayers({
            sortParam,
            sortType: 'desc',
            formatTypeId: currentDraw.data.formatTypeId,
            utrTypeId: event.data.utrTypeId,
        }));
    }
};
export const getDraw = ({ eventId, drawId, isChildDraw, setAsCurrentDraw, dontAutoLoadFirstChildDraw }) => async (dispatch, getState, { mainApi }) => {
    const res = await tmsEventsApi.getDrawEditDraw(mainApi, { eventId, drawId });
    dispatch({ type: DRAW_EDIT_GET_DRAW_SUCCESS, payload: { draw: res.data, isChildDraw, setAsCurrentDraw } });
    dispatch(getDrawOfficials(eventId, drawId));
    // if a grouped draw's parent draw is loaded, store it as parentDraw, and
    // automatically load the first child draw as currentDraw
    if (!isChildDraw && res.data.categoryTypeId === drawCategoryTypeIds.GROUPED && !dontAutoLoadFirstChildDraw) {
        const { draws } = getState().drawEdit;
        if (draws.data) {
            const firstChildDraw = draws.data?.find(draw => draw.id === drawId).childDraws[0];
            if (firstChildDraw) {
                dispatch(getDraw({ eventId, drawId: firstChildDraw.id, isChildDraw: true }));
            }
        }
    }
};

export const getOrderOfPlay = (eventId) => async (dispatch, getState, { mainApi }) => {
    const res = await eventsApi.getOrderOfPlay(mainApi, eventId);
    dispatch({ type: DRAW_EDIT_GET_ORDER_OF_PLAY_SUCCESS, payload: res.data.matches });
};

export const getOrderOfPlayMatches = (eventId) => async (dispatch, getState, { mainApi }) => {
    const res = await tmsEventsApi.getOrderOfPlayMatches(mainApi, { eventId });
    dispatch({ type: DRAW_EDIT_GET_ORDER_OF_PLAY_MATCHES_SUCCESS, payload: res.data });
};

export const getEventTeamStandings = (eventId) => async (dispatch, getState, { mainApi }) => {
    const response = await tmsEventsApi.getTeamStandings(mainApi, eventId);

    if (response.status === responseStatusTypes.OK) {
        dispatch({
            type: DRAW_EDIT_EVENT_TEAM_STANDINGS_SUCCESS,
            payload: response.data.standings,
        });
    }
};

export const getDivisionAcceptanceList = ({ eventId, divisionId }) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: DRAW_EDIT_GET_ACCEPTANCE_LIST, divisionId });
    try {
        const res = await tmsEventsApi.getDivisionAcceptanceList(mainApi, { eventId, divisionId });
        const { data } = res;
        if (data.error) {
            dispatch({ type: DRAW_EDIT_GET_ACCEPTANCE_LIST_FAILURE, divisionId });
        } else if (data) {
            dispatch({ type: DRAW_EDIT_GET_ACCEPTANCE_LIST_SUCCESS, data, divisionId });
        } else {
            dispatch({ type: DRAW_EDIT_GET_ACCEPTANCE_LIST_FAILURE, divisionId });
        }
    } catch {
        dispatch({ type: DRAW_EDIT_GET_ACCEPTANCE_LIST_FAILURE, divisionId });
    }
};

export const getDivisionDrawAssociation = (eventId) => async (dispatch, getState, { mainApi }) => {
    const res = await tmsEventsApi.getDivisionDrawAssociation(mainApi, { eventId });
    dispatch({ type: DRAW_EDIT_GET_DRAW_DIVISION_ASSOCIATION_SUCCESS, payload: res.data });
};

export const setPlayerWildcard = ({ eventId, divisionId, memberId, wildcardStateId }) => async (dispatch, getState, { mainApi }) => {
    const { currentEvent } = getState().events;
    const { acceptance } = currentEvent;
    dispatch({
        type: DRAW_EDIT_SET_PLAYER_WILDCARD,
    });

    try {
        const response = await tmsEventsApi.setPlayerWildcard(mainApi, { eventId, divisionId, memberId, wildcardStateId });
        if (response.status === responseStatusTypes.OK_NO_CONTENT) {
            dispatch({
                type: DRAW_EDIT_SET_PLAYER_WILDCARD_SUCCESS,
                payload: { divisionId, memberId, wildcardStateId },
            });
            if (acceptance && acceptance[divisionId]?.rankingType === acceptanceRankingValues.WTA) {
                dispatch(getDivisionAcceptanceList({ eventId, divisionId }));
            }
        } else {
            dispatch(showErrorPopup({
                error: 'Error setting player wildcard',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error setting player wildcard',
            error,
        }));
    }
};

export const getOrganizerRatings = ({ eventId }) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.getOrganizerRatings(mainApi, { eventId });
        if (res.status === responseStatusTypes.OK) {
            dispatch({
                type: DRAW_EDIT_GET_ORGANIZER_RATINGS_SUCCESS,
                payload: res.data,
            });
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error loading organizer ratings',
            error,
        }));
    }
};

export const setOrganizerRating = ({ eventId, divisionId, memberId, singlesRating, doublesRating }) => async (dispatch, getState, { mainApi }) => {
    try {
        const response = await tmsEventsApi.setOrganizerRating(mainApi, { eventId, divisionId, memberId, singlesRating, doublesRating });
        if (response.status === responseStatusTypes.OK) {
            dispatch({
                type: DRAW_EDIT_SET_ORGANIZER_RATINGS_SUCCESS,
                payload: { divisionId, memberId, singlesRating },
            });
        } else {
            dispatch(showErrorPopup({
                error: 'Error setting organizer rating',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error setting organizer rating',
            error,
        }));
    }
};

export const addToDraw = (payload) => (dispatch) => {
    dispatch({
        type: DRAW_EDIT_ADD_TO_DRAW,
        payload,
    });
};
export const removeFromDraw = (payload) => (dispatch) => {
    dispatch({
        type: DRAW_EDIT_REMOVE_FROM_DRAW,
        payload,
    });
};

export const addToMatch = (payload) => (dispatch) => {
    dispatch(setResetTimer(true));
    dispatch({
        type: DRAW_EDIT_ADD_TO_MATCH,
        payload,
    });
};

export const createTeam = () => (dispatch) => {
    dispatch({
        type: DRAW_EDIT_CREATE_TEAM,
    });
};
export const addTeamToEvent = (payload) => (dispatch) => {
    dispatch({
        type: DRAW_EDIT_ADD_TEAM_TO_EVENT,
        payload,
    });
};

export const splitTeams = (payload) => (dispatch) => {
    dispatch({
        type: DRAW_EDIT_SPLIT_TEAMS,
        payload,
    });
};
export const setSelected = (payload) => (dispatch) => {
    dispatch({
        type: DRAW_EDIT_SET_SELECTED,
        payload,
    });
};
export const setSelectedNotInDraw = (payload) => (dispatch) => {
    dispatch({
        type: DRAW_EDIT_SET_SELECTED_ND,
        payload,
    });
};
export const setSelectedTeams = (payload) => (dispatch) => {
    dispatch({
        type: DRAW_EDIT_SET_SELECTED_TEAMS,
        payload,
    });
};
export const setSelectedTeamsNotInDraw = (payload) => (dispatch) => {
    dispatch({
        type: DRAW_EDIT_SET_SELECTED_TEAMS_ND,
        payload,
    });
};
export const setPreventSelectMove = (payload) => (dispatch) => {
    dispatch({
        type: DRAW_EDIT_SET_PREVENT_SELECT_MOVE,
        payload,
    });
};

export const orderPlayers = (payload) => (dispatch) => {
    dispatch({
        type: DRAW_EDIT_ORDER_PLAYERS,
        payload,
    });
};
export const createDraw = ({ eventId, payload }) => async (dispatch, getState, { mainApi }) => {
    const {
        eliminationTypeId,
        parentDrawEliminationTypeId,
        ...others
    } = payload;
    const isProDraw = parseInt(eliminationTypeId) === drawEliminationTypeIds.PRO_DRAWS;
    let res;
    dispatch(setSavingFlag(true));
    if (isProDraw) {
        const updatedPayload = {
            ...others,
            eliminationTypeId: parentDrawEliminationTypeId,
        };
        res = await tmsEventsApi.createProDraw(mainApi, {
            eventId,
            payload: updatedPayload,
        });
    } else {
        res = await tmsEventsApi.createDraw(mainApi, { eventId, payload });
    }
    dispatch(setSavingFlag(false));
    if (res.data.error) {
        dispatch(showErrorPopup({
            message: 'Error creating draw',
            error: res.data.error,
        }));
    } else {
        dispatch(getDraws(eventId));
        dispatch(getDivisionDrawAssociation(eventId));
        dispatch(getDraw({ eventId, drawId: res.data.id, setAsCurrentDraw: true }));
        return res.data;
    }
};
export const createAutomatedDraw = (payload) => async (dispatch, getState, { mainApi }) => {
    const { event, selected, selectedTeams, teams } = getState().drawEdit;
    try {
        dispatch(setSavingFlag(true));
        if (selected.length) {
            payload.members = [...selected];
            payload.formatTypeId = eventFormatTypeIds.SINGLES;
        } else if (selectedTeams.length) {
            payload.teams = [];
            payload.formatTypeId = eventFormatTypeIds.DOUBLES; // TODO: Siva - do we need to support dingles here?
            selectedTeams.forEach(id => {
                payload.teams.push({
                    id,
                    members: teams.teamsDict[id].members,
                });
            });
        }

        const res = await tmsEventsApi.createAutomatedDraw(mainApi, event.data.id, payload);
        dispatch(setSavingFlag(false));
        dispatch(setSelected([]));
        dispatch(setSelectedTeams([]));
        dispatch(getDraws(event.data.id));
        dispatch(getDraw({ eventId: event.data.id, drawId: res.data.id, setAsCurrentDraw: true }));
        dispatch(getDivisionDrawAssociation(event.data.id));
        return res.data;
    } catch (error) {
        dispatch(setSavingFlag(false));
        dispatch(showErrorPopup({
            message: 'Error creating draw',
            error,
        }));
        throw error;
    }
};

export const updateDraw = ({ payload }) => async (dispatch, getState, { mainApi }) => {
    const { event, draws } = getState().drawEdit;
    dispatch(setSavingFlag(true));
    const {
        eliminationTypeId,
        parentDrawEliminationTypeId,
        ...others
    } = payload;
    const isProDraw = parseInt(eliminationTypeId) === drawEliminationTypeIds.PRO_DRAWS;
    try {
        let res;
        if (isProDraw) {
            const updatedPayload = {
                ...others,
                eliminationTypeId: parentDrawEliminationTypeId,
                id: payload.id,
            };
            res = await tmsEventsApi.updateProDraw(mainApi, {
                eventId: event.data.id,
                payload: updatedPayload,
            });
        } else {
            res = await tmsEventsApi.updateDraw(mainApi, { eventId: event.data.id, drawId: payload.id, payload });
        }
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error creating draw',
                error: res.data.error,
            }));
            return res.data.error;
        }

        // reload draws (also gets updated players and teams)
        await dispatch(getDraws(event.data.id));
        await dispatch(getDivisionDrawAssociation(event.data.id));

        const { drawsDict } = draws;
        const currentDraw = drawsDict[payload.id];
        const parentDraw = drawsDict[currentDraw?.parentDrawId];
        // reload currentDraw
        if (parentDraw?.categoryTypeId === drawCategoryTypeIds.GROUPED) {
            await dispatch(getDraw({ eventId: event.data.id, drawId: parentDraw.id, dontAutoLoadFirstChildDraw: true }));
            await dispatch(getDraw({ eventId: event.data.id, drawId: currentDraw.id, isChildDraw: true }));
        } else {
            await dispatch(getDraw({ eventId: event.data.id, drawId: currentDraw.id, setAsCurrentDraw: true }));
        }
        dispatch(setSavingFlag(false));
        return res.data;
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error updating draw',
            error: getApiErrorMessage(err),
        }));
        dispatch(setSavingFlag(false));
        return err;
    }
};

export const movePlayersApi = ({ eventId, fromDrawId, payload, loadDraw, isChildDraw }) => async (dispatch, getState, { mainApi }) => {
    const { toDrawId } = payload;
    try {
        const drawId = fromDrawId || payload.toDrawId;
        const res = await tmsEventsApi.movePlayers(mainApi, { eventId, fromDrawId: drawId, payload });
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error adding players to draw',
                error: res.data.error,
            }));
            return res.data.error;
        }
        if (loadDraw) {
            dispatch(getDraws(eventId));
            dispatch(getDivisionDrawAssociation(eventId));
            dispatch(getDraw({ eventId, drawId: toDrawId, setAsCurrentDraw: true, isChildDraw }));
            dispatch(setSelected([]));
            dispatch(setSelectedTeams([]));
            dispatch(setSelectedNotInDraw([]));
            dispatch(setSelectedTeamsNotInDraw([]));
        }
        if (res.data.failedMemberIds?.length) {
            dispatch({
                type: DRAW_EDIT_SET_MOVE_FAILED_PLAYERS,
                payload: res.data.failedMemberIds,
            });
        }
        return res.data;
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error adding players to draw',
            error: getApiErrorMessage(err),
        }));
        return err;
    }
};

export const movePlayers = ({ newDraw, toDrawId, isCopy, isChildDraw }) => async (dispatch, getState, { mainApi }) => {
    const { selected, selectedTeams, currentDraw, event, teams } = getState().drawEdit;
    let newDrawId;
    const fromDrawId = currentDraw.data?.id;

    if (newDraw) {
        // create new draw
        const {
            eliminationTypeId,
            parentDrawEliminationTypeId,
            ...others
        } = newDraw;
        let res;
        const isProDraw = parseInt(eliminationTypeId) === drawEliminationTypeIds.PRO_DRAWS;
        if (isProDraw) {
            const updatedPayload = {
                ...others,
                eliminationTypeId: parentDrawEliminationTypeId,
            };
            res = await tmsEventsApi.createProDraw(mainApi, {
                eventId: event.data.id,
                payload: updatedPayload,
            });
        } else {
            res = await tmsEventsApi.createDraw(mainApi, { eventId: event.data.id, payload: newDraw });
        }
        newDrawId = res.data?.id;
    }
    return dispatch(movePlayersApi({
        eventId: event.data.id,
        fromDrawId,
        payload: {
            toDrawId: newDraw ? newDrawId : toDrawId,
            removeFromDraw: !isCopy,
            memberIds: selected,
            teams: populateTeamsForSave(selectedTeams, teams.teamsDict),
        },
        loadDraw: true,
        isChildDraw,
    }));
};

export const autofillDraw = (seedSettings = {}) => async (dispatch, getState, { mainApi }) => {
    const { event, currentDraw } = getState().drawEdit;
    dispatch({ type: DRAW_EDIT_AUTOFILL });
    dispatch({
        type: 'SPLASH_SHOW',
        title: 'Adding Players',
        description: 'Auto-filling your draw...',
    });
    try {
        const res = await tmsEventsApi.autofillDrawV2(mainApi, event.data.id, currentDraw.data.id, seedSettings);
        if (res.data.error) {
            dispatch({
                type: DRAW_EDIT_AUTOFILL_FAILURE,
                res,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
            dispatch(showErrorPopup({
                message: 'Error auto-populating draw',
                error: res.data.error,
            }));
        } else {
            dispatch({
                type: DRAW_EDIT_AUTOFILL_SUCCESS,
                res,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
            dispatch(getDraw({ eventId: event.data.id, drawId: currentDraw.data.id, setAsCurrentDraw: true }));
            return res.data;
        }
    } catch (error) {
        dispatch({
            type: DRAW_EDIT_AUTOFILL_FAILURE,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error auto-populating draw',
            error,
        }));
    }
};

export const autofillDrawRound = (roundId, selected, selectedTeams) => async (dispatch, getState, { mainApi }) => {
    const { event, currentDraw } = getState().drawEdit;
    dispatch({ type: DRAW_EDIT_AUTOFILL });
    dispatch({
        type: 'SPLASH_SHOW',
        title: 'Adding Players',
        description: 'Auto-filling your draw round...',
    });
    try {
        const res = await tmsEventsApi.autofillDrawRoundV2(mainApi, event.data.id, currentDraw.data.id, roundId, selected, selectedTeams);
        if (res.data.error) {
            dispatch({
                type: DRAW_EDIT_AUTOFILL_FAILURE,
                res,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
            dispatch(showErrorPopup({
                message: 'Error auto-populating draw round',
                error: res.data.error,
            }));
        } else {
            dispatch({
                type: DRAW_EDIT_AUTOFILL_SUCCESS,
                res,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
            dispatch(getDraw({ eventId: event.data.id, drawId: currentDraw.data.id, setAsCurrentDraw: true }));
            return res.data;
        }
    } catch (error) {
        dispatch({
            type: DRAW_EDIT_AUTOFILL_FAILURE,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error auto-populating draw round',
            error: getApiErrorMessage(error),
        }));
    }
};

export const setPlayerStatus = (payload) => (dispatch) => {
    dispatch({ type: DRAW_EDIT_SET_PLAYER_STATUS, payload });
};

export const setDrawTag = ({ memberId, teamId, tagId }) => async (dispatch, getState, { mainApi }) => {
    const { event, currentDraw } = getState().drawEdit;
    dispatch({
        type: DRAW_EDIT_SET_DRAW_TAG,
    });

    try {
        const response = await tmsEventsApi.setDrawTag(mainApi, { eventId: event.data.id, drawId: currentDraw.data.id, memberId, teamId, tagId });
        if (response.status === responseStatusTypes.OK_NO_CONTENT) {
            dispatch({
                type: DRAW_EDIT_SET_DRAW_TAG_SUCCESS,
                payload: { memberId, teamId, tagId },
            });
        } else {
            dispatch(showErrorPopup({
                error: 'Error setting draw tag',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error setting draw tag',
            error: getApiErrorMessage(error),
        }));
    }
};

export const saveDrawUpdates = ({ reload }) => async (dispatch, getState, { mainApi }) => {
    const { event, currentDraw, teams } = getState().drawEdit;
    const eventId = event.data.id;
    const drawId = currentDraw.data.id;

    const { drawMembersUpdate, drawWaitlistUpdate } = populateMemberArraysForSave(currentDraw.data, teams.teamsDict);
    const drawMatchUpdates = populateMatchUpdateList(currentDraw.data);

    try {
        dispatch({ type: DRAW_EDIT_SAVE });
        // members update
        const updateDrawMembersResponse = await tmsEventsApi.updateDrawMembers(mainApi, { eventId, drawId, payload: drawMembersUpdate });
        // waitlist save
        let updateDrawWaitlistResponse;
        if (drawWaitlistUpdate.memberIds.length || drawWaitlistUpdate.teamIds.length) {
            updateDrawWaitlistResponse = await tmsEventsApi.updateDrawWaitlist(mainApi, { eventId, drawId, payload: drawWaitlistUpdate });
        }
        // matches save
        let updateMatchesResponse;
        if (drawMatchUpdates.matches.length) {
            updateMatchesResponse = await tmsEventsApi.updateMatches(mainApi, { eventId, drawId, payload: drawMatchUpdates });
        }
        if (updateDrawMembersResponse?.data?.error || updateDrawWaitlistResponse?.data?.error || updateMatchesResponse?.data?.error) {
            dispatch({ type: DRAW_EDIT_SAVE_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error saving draw updates.',
                error: updateDrawMembersResponse?.data?.error || updateDrawWaitlistResponse?.data?.error || updateMatchesResponse?.data?.error,
            }));
        } else {
            dispatch({ type: DRAW_EDIT_SAVE_SUCCESS });
            setTimeout(() => {
                dispatch({ type: DRAW_EDIT_SAVE_SUCCESS_HIDE });
            }, 1000);
        }
        if (reload) {
            // reload draws (also gets updated players and teams)
            dispatch(getDraws(eventId));
            dispatch(getDivisionDrawAssociation(eventId));
            // reload currentDraw
            dispatch(getDraw({ eventId, drawId, setAsCurrentDraw: true }));
        }
        return true;
    } catch (error) {
        dispatch({ type: DRAW_EDIT_SAVE_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error saving draw updates.',
            error,
        }));
    }
};

const fetchDrawEditMatchOnly = (matchId, drawId) => async (dispatch, getState, { mainApi }) => {
    const { event } = getState().drawEdit;
    const res = await tmsEventsApi.getMatch(mainApi, { eventId: event.data.id, drawId, matchId });
    dispatch({ type: DRAW_EDIT_GET_MATCH_SUCCESS, payload: res.data });
    return res.data;
};

export const getMatch = (matchId) => async (dispatch, getState) => {
    const { currentDraw } = getState().drawEdit;
    const drawId = currentDraw.data.id;
    const saved = await dispatch(fetchDrawEditMatchOnly(matchId, drawId));

    const cascadeFetches = [];
    if (saved.winnerOutputMatchId) {
        const { drawId: winnerDrawId } = findMatchAcrossSlices(saved.winnerOutputMatchId, {
            currentDraw,
            // Draw-edit context: cascade is scoped to currentDraw only.
            // Cross-draw output matches are not fetched; winner/loser cascade assumes
            // output matches are in the same draw being edited.
            matchSheet: null,
            orderOfPlaySchedule: null,
        });
        if (winnerDrawId) {
            cascadeFetches.push(dispatch(fetchDrawEditMatchOnly(saved.winnerOutputMatchId, winnerDrawId)));
        }
    }
    if (saved.loserOutputMatchId) {
        const { drawId: loserDrawId } = findMatchAcrossSlices(saved.loserOutputMatchId, {
            currentDraw,
            // Draw-edit context: cascade is scoped to currentDraw only.
            // Cross-draw output matches are not fetched; winner/loser cascade assumes
            // output matches are in the same draw being edited.
            matchSheet: null,
            orderOfPlaySchedule: null,
        });
        if (loserDrawId) {
            cascadeFetches.push(dispatch(fetchDrawEditMatchOnly(saved.loserOutputMatchId, loserDrawId)));
        }
    }

    await Promise.all(cascadeFetches);
};

export const postScore = (resultObj) => async (dispatch, getState, { mainApi }) => {
    const { event, currentDraw } = getState().drawEdit;
    const { matchId } = resultObj;

    if (event.data.sportTypeId === sportTypeIds.PICKLEBALL || currentDraw.data.formatTypeId === divisionFormatTypeIds.DINGLES) {
        await api.postSinglePointScore(mainApi, resultObj);
    } else {
        await api.postScore(mainApi, resultObj);
    }

    dispatch(getMatch(matchId));
    // reload draw to update which player has posted score (to prevent remove/move players with score)
    dispatch(reloadDraw(true));
};
export const clearScore = (resultObj) => async (dispatch, getState, { mainApi }) => {
    const { event, currentDraw } = getState().drawEdit;
    const { id } = resultObj;
    if (event.data.sportTypeId === sportTypeIds.PICKLEBALL || currentDraw.data.formatTypeId === divisionFormatTypeIds.DINGLES) {
        await api.clearSinglePointScore(mainApi, {
            ...resultObj,
            matchId: id,
        });
    } else {
        await api.clearScore(mainApi, resultObj);
    }
    dispatch(getMatch(id));
};
export const publishDraws = (selectedArr) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: DRAW_EDIT_PUBLISH });
    try {
        dispatch({
            type: 'SPLASH_SHOW_BALL',
            title: 'Event Desk',
            description: 'Publishing Draws...',
        });
        const { event, draws } = getState().drawEdit;
        const eventId = event.data.id;
        const payload = {
            draws: draws.data.map(draw => {
                if (!(draw.published && draw.hasScore)) {
                    draw.published = selectedArr.includes(draw.id);
                }
                return {
                    id: draw.id,
                    published: draw.published,
                };
            }),
        };
        const res = await tmsEventsApi.publishDrawsV2(mainApi, { eventId, payload });
        if (res.StatusCode && res.StatusCode === 400) {
            dispatch({ type: DRAW_EDIT_PUBLISH_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error publishing draws.',
                error: res.DisplayMessage,
            }));
        } else {
            dispatch({ type: DRAW_EDIT_PUBLISH_SUCCESS });
            dispatch(getDraws(eventId));
            dispatch(getDivisionDrawAssociation(eventId));
            dispatch({
                type: 'SPLASH_HIDE',
            });
            return true;
        }
    } catch (error) {
        dispatch({ type: DRAW_EDIT_PUBLISH_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error publishing draws.',
            error: getApiErrorMessage(error),
        }));
        throw error;
    }
};

export const saveOrderOfPlay = (eventId, matchId, orderOfPlay) => async (dispatch, getState, { mainApi }) => {
    try {
        const orderOfPlayPayload = {
            ...orderOfPlay,
        };

        const res = await eventsApi.saveOrderOfPlay(mainApi, eventId, orderOfPlayPayload);

        if (res.status === responseStatusTypes.OK) {
            dispatch({
                type: DRAW_EDIT_SAVE_ORDER_OF_PLAY_SUCCESS,
                payload: {
                    matchId,
                    ...orderOfPlay,
                },
            });
            dispatch(getOrderOfPlay(eventId));
            dispatch(getOrderOfPlayMatches(eventId));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error saving order of play.',
            error,
        }));
        throw error;
    }
};

export const deleteOrderOfPlay = (eventId, matchId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await eventsApi.deleteOrderOfPlay(mainApi, eventId, matchId);
        if (res.status === responseStatusTypes.OK) {
            dispatch({
                type: DRAW_EDIT_DELETE_ORDER_OF_PLAY_SUCCESS,
                payload: {
                    matchId,
                },
            });
            dispatch(getOrderOfPlay(eventId));
            dispatch(getOrderOfPlayMatches(eventId));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error deleting order of play.',
            error,
        }));
        throw error;
    }
};

export const updateEventSchedule = (scheduleType, showSplash = false) => async (dispatch, getState, { mainApi }) => {
    const { event } = getState().drawEdit;
    if (showSplash) {
        dispatch({
            type: 'SPLASH_SHOW',
        });
    }
    try {
        const res = await tmsEventsApi.updateScheduleType(mainApi, event.data.id, {
            drawSchedule: scheduleType.value,
        });
        const { data } = res;
        if (data.error) {
            dispatch(showErrorPopup({
                message: 'Error updating schedule type',
                error: data.error,
            }));
        } else {
            dispatch({
                type: DRAW_EDIT_UPDATE_SCHEDULE_TYPE,
                payload: scheduleType,
            });
            if (scheduleType.id === drawScheduleTypeIds.ORDER_OF_PLAY) {
                dispatch(getOrderOfPlay(event.data.id));
                dispatch(getOrderOfPlayMatches(event.data.id));
            } else if (scheduleType.id === drawScheduleTypeIds.MATCH_SHEET) {
                dispatch(getMatchSheet(event.data.id));
            }
        }
        dispatch({
            type: 'SPLASH_HIDE',
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error updating schedule type',
            error: err,
        }));
        dispatch({
            type: 'SPLASH_HIDE',
        });
    }
};

export const reloadDraw = (dontAutoLoadFirstChildDraw) => async (dispatch, getState) => {
    const { event, currentDraw } = getState().drawEdit;
    dispatch(getDraw({ eventId: event.data.id, drawId: currentDraw.data.id, setAsCurrentDraw: true, dontAutoLoadFirstChildDraw }));
};

export const setResetTimer = (bool) => (dispatch) => {
    dispatch({ type: DRAW_EDIT_SET_RESET_TIMER, payload: bool });
};

// ------------------------------

export const getEventLocations = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: DRAW_EDIT_LOCATIONS_FETCH_REQUEST });
        const res = await tmsEventsApi.getEventLocations(mainApi, eventId);
        const { data } = res;
        if (data.error) {
            dispatch({ type: DRAW_EDIT_LOCATIONS_FETCH_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error loading locations.',
                error: data.error,
            }));
        } else {
            dispatch({ type: DRAW_EDIT_LOCATIONS_FETCH_SUCCESS, data });
        }
    } catch {
        dispatch({
            type: DRAW_EDIT_LOCATIONS_FETCH_FAILURE,
        });
    }
};

export const getEventFacilities = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: DRAW_EDIT_FACILITIES_FETCH_REQUEST });
        const res = await tmsEventsApi.getEventFacilities(mainApi, eventId);
        const { data } = res;
        if (data.error) {
            dispatch({ type: DRAW_EDIT_FACILITIES_FETCH_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error loading event facilities.',
                error: data.error,
            }));
        } else {
            dispatch({ type: DRAW_EDIT_FACILITIES_FETCH_SUCCESS, data });
        }
    } catch {
        dispatch({
            type: DRAW_EDIT_FACILITIES_FETCH_FAILURE,
        });
    }
};

export const getMatchSheet = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.getMatchSheet(mainApi, eventId);
        const { data } = res;
        dispatch({ type: DRAW_EDIT_FETCH_MATCH_SHEET_SUCCESS, data: data.matches });
    } catch (error) {
        console.log(error);
    }
};

export const updateMatchSheet = ({ matchId, payload }) => async (dispatch, getState, { mainApi }) => {
    const { event } = getState().drawEdit;
    try {
        dispatch({ type: DRAW_EDIT_UPDATE_MATCH_SHEET_REQUEST });
        const res = await tmsEventsApi.updateMatchSheet(mainApi, event.data.id, matchId, payload);
        if (res.data?.error) {
            dispatch({ type: DRAW_EDIT_UPDATE_MATCH_SHEET_FAILURE });
        } else {
            dispatch({ type: DRAW_EDIT_UPDATE_MATCH_SHEET_SUCCESS, data: { matchId, payload } });
            dispatch(getMatchSheet(event.data.id));
        }
    } catch {
        dispatch({ type: DRAW_EDIT_UPDATE_MATCH_SHEET_FAILURE });
    }
};

export const updateMatchSheetRound = ({ roundId, payload }) => async (dispatch, getState, { mainApi }) => {
    const { event } = getState().drawEdit;
    try {
        dispatch({ type: DRAW_EDIT_UPDATE_MATCH_SHEET_ROUND_REQUEST });
        const res = await tmsEventsApi.updateMatchSheetRound(mainApi, event.data.id, roundId, payload);
        const { data } = res;
        if (data.error) {
            dispatch({ type: DRAW_EDIT_UPDATE_MATCH_SHEET_ROUND_FAILURE });
        } else {
            dispatch({ type: DRAW_EDIT_UPDATE_MATCH_SHEET_ROUND_SUCCESS, data: { roundId, payload } });
            dispatch(getMatchSheet(event.data.id));
        }
    } catch {
        dispatch({ type: DRAW_EDIT_UPDATE_MATCH_SHEET_ROUND_FAILURE });
    }
};

export const removeMatchSheet = (matchId) => async (dispatch, getState, { mainApi }) => {
    const { event } = getState().drawEdit;
    try {
        const res = await tmsEventsApi.deleteMatchSheet(mainApi, event.data.id, matchId);
        if (res.status === responseStatusTypes.OK) {
            dispatch({ type: DRAW_EDIT_DELETE_MATCH_SHEET_SUCCESS, payload: { matchId } });
            dispatch(getMatchSheet(event.data.id));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error deleting match sheet.',
            error,
        }));
        throw error;
    }
};

export const removeCourtExclusionList = (exclusionList) => async (dispatch, getState, { mainApi }) => {
    try {
        const { event } = getState().drawEdit;
        dispatch({ type: DRAW_EDIT_LOCATIONS_EXCLUDE_REQUEST });

        await tmsEventsApi.removeCourtFromEventExclusions(mainApi, event.data.id, { courts: exclusionList });

        dispatch({ type: DRAW_EDIT_LOCATIONS_EXCLUDE_SUCCESS });
        dispatch(getEventLocations(event.data.id));
    } catch {
        dispatch({
            type: DRAW_EDIT_LOCATIONS_EXCLUDE_FAILURE,
        });
    }
};

export const addCourtExclusionList = (exclusionList) => async (dispatch, getState, { mainApi }) => {
    try {
        const { event } = getState().drawEdit;

        dispatch({ type: DRAW_EDIT_LOCATIONS_EXCLUDE_REQUEST });

        await tmsEventsApi.addCourtToEventExclusions(mainApi, event.data.id, { courts: exclusionList });

        dispatch({ type: DRAW_EDIT_LOCATIONS_EXCLUDE_SUCCESS });
        dispatch(getEventLocations(event.data.id));
    } catch {
        dispatch({
            type: DRAW_EDIT_LOCATIONS_EXCLUDE_FAILURE,
        });
    }
};

export const getEventOfficials = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: DRAW_EDIT_OFFICIALS_FETCH_REQUEST });
        const res = await tmsEventsApi.getEventOfficials(mainApi, eventId);
        const { data } = res;
        if (data.error) {
            dispatch({ type: DRAW_EDIT_OFFICIALS_FETCH_FAILURE });
        } else {
            dispatch({ type: DRAW_EDIT_OFFICIALS_FETCH_SUCCESS, payload: data });
        }
    } catch {
        dispatch({
            type: DRAW_EDIT_OFFICIALS_FETCH_FAILURE,
        });
    }
};

export const saveEventOfficial = (eventId, payload) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: DRAW_EDIT_OFFICIALS_UPDATE_REQUEST });
        const res = await tmsEventsApi.saveEventOfficial(mainApi, eventId, payload);
        const { data } = res;
        if (data.error) {
            dispatch({ type: DRAW_EDIT_OFFICIALS_UPDATE_FAILURE });
            throw new Error('Error saving event official.');
        } else {
            dispatch({ type: DRAW_EDIT_OFFICIALS_UPDATE_SUCCESS, data });
            dispatch(getEventOfficials(eventId));
        }
    } catch {
        dispatch({
            type: DRAW_EDIT_OFFICIALS_UPDATE_FAILURE,
        });
        throw new Error('Error saving event official.');
    }
};

export const updateEventOfficial = (eventId, officialId, payload) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: DRAW_EDIT_OFFICIALS_UPDATE_REQUEST });
        const res = await tmsEventsApi.updateEventOfficial(mainApi, eventId, officialId, payload);
        const { data } = res;
        if (data.error) {
            dispatch({ type: DRAW_EDIT_OFFICIALS_UPDATE_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error updating event official.',
                error: res.data.error,
            }));
        } else {
            dispatch({ type: DRAW_EDIT_OFFICIALS_UPDATE_SUCCESS, data });
            dispatch(getEventOfficials(eventId));
        }
    } catch (error) {
        dispatch({
            type: DRAW_EDIT_OFFICIALS_UPDATE_FAILURE,
        });
        dispatch(showErrorPopup({
            message: 'Error updating event official.',
            error,
        }));
    }
};

export const inactivateEventOfficial = (eventId, officialId, payload) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: DRAW_EDIT_OFFICIALS_UPDATE_REQUEST });
        const res = await tmsEventsApi.inactivateEventOfficial(mainApi, eventId, officialId, payload);
        const { data } = res;
        if (data.error) {
            dispatch({ type: DRAW_EDIT_OFFICIALS_UPDATE_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error removing event official.',
                error: res.data.error,
            }));
        } else {
            dispatch({ type: DRAW_EDIT_OFFICIALS_UPDATE_SUCCESS, data });
            dispatch(getEventOfficials(eventId));
        }
    } catch (error) {
        dispatch({
            type: DRAW_EDIT_OFFICIALS_UPDATE_FAILURE,
        });
        dispatch(showErrorPopup({
            message: 'Error removing event official.',
            error,
        }));
    }
};

export const getMatchOfficials = (eventId, drawId, matchId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: DRAW_EDIT_GET_MATCH_OFFICIALS_REQUEST });
        const res = await tmsEventsApi.getMatchOfficials(mainApi, eventId, matchId);
        const { data } = res;
        if (data.error) {
            dispatch({ type: DRAW_EDIT_GET_MATCH_OFFICIALS_FAILURE });
        } else {
            dispatch({
                type: DRAW_EDIT_GET_MATCH_OFFICIALS_SUCCESS,
                payload: { drawId, matchId, data: data.officials },
            });
        }
    } catch {
        dispatch({ type: DRAW_EDIT_GET_MATCH_OFFICIALS_FAILURE });
    }
};

export const getDrawOfficials = (eventId, drawId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: DRAW_EDIT_GET_DRAW_OFFICIALS_REQUEST });
        const res = await tmsEventsApi.getDrawOfficials(mainApi, eventId, drawId);
        const { data } = res;
        if (data.error) {
            dispatch({ type: DRAW_EDIT_GET_DRAW_OFFICIALS_FAILURE });
        } else {
            dispatch({
                type: DRAW_EDIT_GET_DRAW_OFFICIALS_SUCCESS,
                payload: { drawId, eventId, data },
            });
        }
    } catch {
        dispatch({ type: DRAW_EDIT_GET_DRAW_OFFICIALS_FAILURE });
    }
};

export const addMatchOfficial = ({ drawId, matchId, payload }) => async (dispatch, getState, { mainApi }) => {
    const { event } = getState().drawEdit;
    try {
        dispatch({ type: DRAW_EDIT_ADD_MATCH_OFFICIAL_REQUEST });
        const res = await tmsEventsApi.addMatchOfficial(mainApi, event.data.id, drawId, matchId, payload);
        const { data } = res;
        if (data.error) {
            dispatch({ type: DRAW_EDIT_ADD_MATCH_OFFICIAL_FAILURE });
            dispatch(showErrorPopup({
                message: 'Adding match official failed.',
                error: data.error,
            }));
        } else {
            dispatch(getDrawOfficials(event.data.id, drawId));
        }
    } catch {
        dispatch({ type: DRAW_EDIT_ADD_MATCH_OFFICIAL_FAILURE });
    }
};

export const deleteMatchOfficial = ({ drawId, matchId, payload }) => async (dispatch, getState, { mainApi }) => {
    const { event } = getState().drawEdit;
    try {
        dispatch({ type: DRAW_EDIT_DELETE_MATCH_OFFICIAL_REQUEST });
        const res = await tmsEventsApi.deleteMatchOfficial(mainApi, event.data.id, drawId, matchId, payload);
        const { data } = res;
        if (data.error) {
            dispatch({ type: DRAW_EDIT_DELETE_MATCH_OFFICIAL_FAILURE });
            dispatch(showErrorPopup({
                message: 'Deleting match official failed.',
                error: data.error,
            }));
        } else {
            dispatch(getDrawOfficials(event.data.id, drawId));
        }
    } catch {
        dispatch({ type: DRAW_EDIT_DELETE_MATCH_OFFICIAL_FAILURE });
    }
};

export const sendMessageToPlayers = (message, eventId, drawId, sendCopyToOrganizer = false) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await api.sendMessage(mainApi, message, eventId, drawId, sendCopyToOrganizer);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error Sending Message',
                error: res.data.error,
            }));
        } else {
            dispatch(showSuccessToast({ message: 'Message Sent' }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error Sending Message',
            error: error.response.data,
        }));
    }
};

export const setSavingFlag = (bool) => (dispatch) => {
    dispatch({ type: DRAW_EDIT_SET_SAVING_FLAG, payload: bool });
};

export const toggleEventSMSEnabled = (eventId, smsEnabled) => async (dispatch, getState, { mainApi }) => {
    try {
        await tmsEventsApi.toggleEventSMSEnabled(mainApi, { eventId, smsEnabled });
        dispatch({ type: DRAW_EDIT_TOGGLE_SMS_FLAG, payload: smsEnabled });
        dispatch(showSuccessToast({ message: `SMS players ${smsEnabled ? 'enabled' : 'disabled'}` }));
    } catch (error) {
        console.log(error);
        dispatch(showErrorPopup({
            message: 'Error Toggling SMS, Refresh page or contact support',
            error,
        }));
    }
};

export const printMatchSheet = ({ reload, matchId }) => async (dispatch, getState, { mainApi }) => {
    const { event, currentDraw } = getState().drawEdit;
    const eventId = event.data.id;
    const drawId = currentDraw.data.id;

    const printMatchUpdates = populatePrintMatchSheetUpdateList(currentDraw.data, matchId);

    try {
        dispatch({ type: DRAW_EDIT_SAVE });
        // matches save
        let updateMatchesResponse;
        if (printMatchUpdates.matches.length) {
            updateMatchesResponse = await tmsEventsApi.updatePrintMatchSheet(mainApi, { eventId, drawId, payload: printMatchUpdates });
        }
        if (updateMatchesResponse?.data?.error) {
            dispatch({ type: DRAW_EDIT_SAVE_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error printing match sheet.',
                error: updateMatchesResponse.data.error,
            }));
        } else {
            dispatch({ type: DRAW_EDIT_SAVE_SUCCESS });
            setTimeout(() => {
                dispatch({ type: DRAW_EDIT_SAVE_SUCCESS_HIDE });
            }, 1000);
        }
        if (reload) {
            // reload currentDraw
            dispatch(getDraw({ eventId, drawId, setAsCurrentDraw: true }));
        }
        return true;
    } catch (error) {
        dispatch({ type: DRAW_EDIT_SAVE_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error printing match sheet.',
            error,
        }));
    }
};

export const printMultipleMatchSheets = ({ eventId, drawId, matchesIds }) => async (dispatch, getState, { mainApi }) => {
    const printMatchUpdates = populatePrintMultipleMatchesSheetUpdateList(matchesIds);

    try {
        dispatch({ type: DRAW_EDIT_SAVE });
        // matches save
        let updateMatchesResponse;
        if (printMatchUpdates.matches.length) {
            updateMatchesResponse = await tmsEventsApi.updatePrintMatchSheet(mainApi, { eventId, drawId, payload: printMatchUpdates });
        }
        if (updateMatchesResponse?.data?.error) {
            dispatch({ type: DRAW_EDIT_SAVE_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error printing match sheet.',
                error: updateMatchesResponse.data.error,
            }));
        } else {
            dispatch({ type: DRAW_EDIT_SAVE_SUCCESS });
        }
        return true;
    } catch (error) {
        dispatch({ type: DRAW_EDIT_SAVE_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error printing match sheet.',
            error,
        }));
    }
};

export const confirmDivisionDrawAssociation = () => async (dispatch, getState, { mainApi }) => {
    const { event } = getState().drawEdit;
    const eventId = event.data?.id;

    try {
        const response = await tmsEventsApi.confirmDivisionDrawAssociation(mainApi, { eventId });
        dispatch({ type: DRAW_EDIT_CONFIRM_DIVISION_DRAW_ASSOCIATION_SUCCESS });
        if (response.status === responseStatusTypes.OK) {
            // do nothing at the moment
        } else {
            dispatch(showErrorPopup({
                error: 'Error setting preference',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error setting preference',
            error,
        }));
    }
};

export const getEventDirectors = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.getEventDirectors(mainApi, eventId);
        const { data } = res;
        return data;
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error getting event directors',
            error: getApiErrorMessage(err),
        }));
    }
};

export const setMoveFailedPlayers = (payload) => (dispatch) => {
    dispatch({
        type: DRAW_EDIT_SET_MOVE_FAILED_PLAYERS,
        payload,
    });
};

export const addEventVolunteer = (eventId, payload) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.addEventVolunteer(mainApi, eventId, payload);
        if (res.status !== 200) {
            dispatch(showErrorToast({
                message: res.DisplayMessage,
            }));
        }
        return res;
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error adding event volunteer',
            error: err,
        }));
        return false;
    }
};

export const addEventAdmin = (eventId, payload) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.addEventAdmin(mainApi, eventId, payload);
        if (res.status !== 200) {
            dispatch(showErrorToast({
                message: res.DisplayMessage,
            }));
        }
        return res;
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error adding event admin',
            error: err,
        }));
        return false;
    }
};

export const deleteEventDirector = (eventId, memberId) => async (dispatch, getState, { mainApi }) => {
    try {
        return await tmsEventsApi.deleteEventDirector(mainApi, eventId, memberId);
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error deleting event director',
            error: err,
        }));
        return false;
    }
};

export const getCheckInPlayers = (eventId, query = '', date = 'all', sortType = 'asc') => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.getCheckInPlayers(mainApi, eventId, query, date, sortType);
        const { data } = res;
        return data;
    } catch (err) {
        console.log('ERROR', err);
    }
};

export const getPlayerInfoForCheckIn = (eventId, memberId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.getPlayerInfoForCheckIn(mainApi, eventId, memberId);
        const { data } = res;
        return data;
    } catch (err) {
        console.log('ERROR', err);
    }
};

export const submitPlayerCheckIn = (eventId, memberId, payload) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.submitPlayerCheckIn(mainApi, eventId, memberId, payload);
        if (res.status === 200) {
            dispatch({
                type: 'DRAW_EDIT_UPDATE_CHECK_IN_STATUS_SUCCESS',
                payload: { memberId, checkIns: payload.checkIns },
            });
            return res;
        }
        return false;
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error submitting player check-in',
            error: err,
        }));
        return false;
    }
};

export const updateHideSeedNumbers = (hideSeedNumbers = true) => async (dispatch, getState, { mainApi }) => {
    const { event, currentDraw } = getState().drawEdit;
    try {
        const res = await tmsEventsApi.updateHideSeedNumbers(mainApi, event.data.id, currentDraw.data.id, { hideSeedNumbers });
        if (res.status === 200) {
            return res;
        }
        return false;
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error updating hide seed numbers',
            error: err,
        }));
        return false;
    }
};

export const deleteDraw = (eventId, drawId) => async (dispatch, getState, { mainApi }) => {
    try {
        await tmsEventsApi.deleteDrawV2(mainApi, eventId, drawId);
        dispatch(getDraws(eventId));
        dispatch(getDivisionDrawAssociation(eventId));
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error deleting draw',
            error: getApiErrorMessage(error),
        }));
        return false;
    }
};

export const getDrawsPublishInfo = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.getDrawsPublishInfo(mainApi, eventId);
        const { data } = res;
        if (res.status === 200) {
            dispatch({
                type: DRAW_EDIT_GET_DRAWS_PUBLISH_INFO_SUCCESS,
                payload: data,
            });
            return data;
        }
        return false;
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error getting draws publish data',
            error: getApiErrorMessage(err),
        }));
    }
};

export const deleteScheduledAutoPublishDraws = (eventId, drawIds) => async (dispatch, getState, { mainApi }) => {
    try {
        await tmsEventsApi.deleteAutoPublishScheduled(mainApi, eventId, { drawIds });
        dispatch(getDrawsPublishInfo(eventId));
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error deleting scheduled draw',
            error: getApiErrorMessage(error),
        }));
        return false;
    }
};

export const scheduleAutoPublishDraws = (eventId, payload) => async (dispatch, getState, { mainApi }) => {
     try {
        await tmsEventsApi.scheduleAutoPublishDraws(mainApi, eventId, payload);
        dispatch(getDrawsPublishInfo(eventId));
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error scheduling auto publish draws',
            error: getApiErrorMessage(error),
        }));
        return false;
    }
};
